// export const host = "https://kuky.lt/api";
export const host = "http://localhost:8088/api";
export const API_KEY = "f686b561bc2443e9b96ec5190146425f";
export const BACKUP_API_KEY = "0cfc4addf7564bd9b69a73949b9beced";
export const WP_API_URL = "http://localhost/wordpress/wp-json";
